type CountryType = Record<string, Record<string, string>[]>

export enum COUNTRY_DATA_KEY {
  COUNTRY_SELECTION_DATA = 'COUNTRY_SELECTION_DATA',
  PHONE_NUMBER_DATA = 'PHONE_NUMBER_DATA',
  LANGUAGE_SELECTION_DATA = 'LANGUAGE_SELECTION_DATA',
}

export const COUNTRY_SELECTION_DATA = [
  {
    flag: 'TR',
    value: 'TR',
    text: 'countryCodes.TR',
    prefix: '+90',
  },
  {
    flag: 'DE',
    value: 'DE',
    text: 'countryCodes.DE',
    prefix: '+49',
  },
]

export const LANGUAGE_SELECTION_DATA = [
  {
    flag: 'TR',
    value: 'tr',
    text: 'TR',
  },
  {
    flag: 'GB',
    value: 'en',
    text: 'EN',
  },
  {
    flag: 'DE',
    value: 'de',
    text: 'DE',
  },
]

export const PHONE_NUMBER_DATA = [
  ...COUNTRY_SELECTION_DATA,
  {
    flag: 'PL',
    value: 'PL',
    text: 'countryCodes.PL',
    prefix: '+48',
  },
]

export const COUNTRIES: CountryType = {
  COUNTRY_SELECTION_DATA,
  PHONE_NUMBER_DATA,
  LANGUAGE_SELECTION_DATA,
}

export const getCountries = (key: string, t: (arg: string) => void) => {
  return COUNTRIES[key].map((item: { value?: string; text?: string; prefix?: string }) => ({
    ...item,
    text: t(item.text || ''),
  }))
}
